module.exports = __webpack_public_path__ + "img/show-results-icon.43885aca.png";